export const DOCUMENT_PATTERN_MODALS = {
  create: 'create',
  delete: 'delete',
  edit: 'edit',
};

export const DOCUMENT_PATTERN_TYPE = {
  _id: '',
  title: '',
  separator: '',
  valueEmployeeId: '',
  companyId: '',
  createdAt: '',
};
